var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.item && _vm.item.type == 'image')?_c('img',{staticClass:"center",attrs:{"src":_vm.item.src}}):_vm._e(),(_vm.item && _vm.item.type == 'pdf')?_c('iframe',{attrs:{"src":_vm.item.src,"width":"100%","height":"100%","frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }